/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import * as S from './styles';

import accessGroupColumns from './columns/accessGroup';
import contactColumns from './columns/contact';
import userColumns from './columns/user';

const components = {
    accessGroupColumns,
    contactColumns,
    userColumns
}

export { components }